import React, { useEffect, useState } from 'react';
import NewOrder from './newOrder';
import OrderDetails from './orderDetails';
import { useApiBaseUrl } from '../context/ApiContext';
import { EditingProvider } from './EditingContext';

const Orders = ({ SelectedCustomerId, SelectedOrderId, handleSetNewOrderId, usernameEmail, handleOrderDeleted, handleRowClick }) => {
  const ApiBaseUrl = useApiBaseUrl();
  const [orderSummaries, setOrderSummaries] = useState([]);
  const [ShowNewOrderScreen, setShowNewOrderScreen] = useState(false);
  const [OrderCycleInfo, setOrderCycleInfo] = useState(null);

  const _handleOrderDeleted = () => {
    setShowNewOrderScreen(false);
    handleOrderDeleted();
  };

  useEffect(() => {
    const fetchOrderCycleInfo = async () => {
      try {
        const response = await fetch(`${ApiBaseUrl}/api/Sales/GetOrderCycleInfo`);
        const data = await response.json();
        setOrderCycleInfo(data);
        console.log('OrderCycleInfo retrieved from GetOrderCycleInfo:', data);
      } catch (error) {
        console.error('Error fetching order cycle info:', error);
      }
    };

    fetchOrderCycleInfo();
  }, []);

  const handleNewOrderClick = () => {
    setShowNewOrderScreen(true);
  };

  const handleClosePopup = () => {
    setShowNewOrderScreen(false);
  };

  useEffect(() => {
    const fetchOrderSummaries = async () => {
      try {
        const response = await fetch(`${ApiBaseUrl}/api/Sales/${SelectedCustomerId}/GetOrderSummaries_ByCustomerId`);
        const data = await response.json();
        const sortedOrderSummaries = [...data.data]
          .filter(order => order.totalWeight !== 0)
          .sort((a, b) => new Date(a.estimatedShipmentDate) - new Date(b.estimatedShipmentDate));
          setOrderSummaries({ data: sortedOrderSummaries, message: data.message, success: data.success });
          console.log('orderSummaries retrieved from GetOrderSummaries_ByCustomerId:', sortedOrderSummaries);
      } catch (error) {
        console.error('Error fetching order summaries:', error);
      }
    };

    if (SelectedCustomerId != '') {
      fetchOrderSummaries();
    }
  }, []);
  

  return (
    <>
    {SelectedOrderId === "" ? (
    <>
    <div>
        <button style={{height: '64px', width: '256px', marginTop: '16px', backgroundColor: 'red', color: 'white'}} onClick={handleNewOrderClick}>Create New Order</button>
      </div>
      <div className="order-summaries" style={{ background: 'white', border: 'solid 1px', width: '70%', margin: 'auto', marginTop: '24px' }}>
        <h2>Order History</h2>
        <div className="order-summary">
          <table style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>Purchase No.</th>
                <th>Order No</th>
                <th>Date Created</th>
                <th>Requested Ship Date</th>
                <th>Order Status</th>
                <th>Total Weight</th>
                <th>Warehouse Location</th>
              </tr>
            </thead>
            <tbody>
              {orderSummaries.data ? 
                orderSummaries.data.map((order, index) => (
                <tr key={index} onClick={() => handleRowClick(order.orderNo)}>
                  <td>{order.custOrderNo}</td>
                  <td>{order.orderNo}</td>
                  <td>
                    {
                    new Date(order.creationDate).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit'})
                    }
                  </td>
                  <td>
                    {
                    new Date(order.estimatedShipmentDate).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit'})
                    }
                  </td>
                  <td>{order.status === 0 ? "Open" : order.status === 1 ? "Ready" : ""}</td>
                  <td>{order.totalWeight} lbs</td>
                  <td>{order.warehouseLocation}</td>
                </tr>
              )) : (
                <tr>
                  <td colSpan="7">No orders found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      
      {ShowNewOrderScreen && <NewOrder selectedCustomerId={SelectedCustomerId} 
        onClose={handleClosePopup} handleSetNewOrderId={handleSetNewOrderId} />}
    </>
    ) : (
      <div>
        Selected Order ID: {SelectedOrderId}
        <EditingProvider>
          <OrderDetails orderId={SelectedOrderId} SelectedCustomerId={SelectedCustomerId}
                        OrderCycleInfo={OrderCycleInfo} usernameEmail={usernameEmail}
                        handleOrderDeleted={_handleOrderDeleted} />
        </EditingProvider>
      </div>
    )}
    
    </>

  );


};

export default Orders;